export default {
  comdex: {
    chainId: "",
    rpc: process.env.VUE_APP_KEPLR_COMDEX_RPC,
    rest: process.env.VUE_APP_KEPLR_COMDEX_REST,
    chainName: "Comdex",
    stakeCurrency: {
      coinDenom: "CMDX",
      coinMinimalDenom: "ucmdx",
      coinDecimals: 6,
      coinGeckoId: "comdex",
    },
    walletUrlForStaking: `https://app.unagii.com/stake/comdex`,
    bip44: {
      coinType: 118,
    },
    bech32Config: {
      bech32PrefixAccAddr: "comdex",
      bech32PrefixAccPub: "comdexpub",
      bech32PrefixValAddr: "comdexvaloper",
      bech32PrefixValPub: "comdexvaloperpub",
      bech32PrefixConsAddr: "comdexvalcons",
      bech32PrefixConsPub: "comdexvalconspub",
    },
    currencies: [
      {
        coinDenom: "CMDX",
        coinMinimalDenom: "ucmdx",
        coinDecimals: 6,
        coinGeckoId: "comdex",
      },
    ],
    feeCurrencies: [
      {
        coinDenom: "CMDX",
        coinMinimalDenom: "ucmdx",
        coinDecimals: 6,
        coinGeckoId: "comdex",
      },
    ],
    coinType: 118,
    gasPriceStep: {
      low: 0.01,
      average: 0.025,
      high: 0.04,
    },
  },
  lum: {
    chainId: "",
    rpc: process.env.VUE_APP_KEPLR_LUM_RPC,
    rest: process.env.VUE_APP_KEPLR_LUM_REST,
    chainName: "Lum Network",
    stakeCurrency: {
      coinDenom: "LUM",
      coinMinimalDenom: "ulum",
      coinDecimals: 6,
      coinGeckoId: "lum-network",
    },
    walletUrlForStaking: `https://app.unagii.com/stake/lum`,
    bip44: {
      coinType: 118,
    },
    bech32Config: {
      bech32PrefixAccAddr: "lum",
      bech32PrefixAccPub: "lumpub",
      bech32PrefixValAddr: "lumvaloper",
      bech32PrefixValPub: "lumvaloperpub",
      bech32PrefixConsAddr: "lumvalcons",
      bech32PrefixConsPub: "lumvalconspub",
    },
    currencies: [
      {
        coinDenom: "LUM",
        coinMinimalDenom: "ulum",
        coinDecimals: 6,
        coinGeckoId: "lum-network",
      },
    ],
    feeCurrencies: [
      {
        coinDenom: "LUM",
        coinMinimalDenom: "ulum",
        coinDecimals: 6,
        coinGeckoId: "lum-network",
      },
    ],
    coinType: 118,
    gasPriceStep: {
      low: 0.01,
      average: 0.025,
      high: 0.04,
    },
  },
  injective: {
    chainId: "",
    rpc: process.env.VUE_APP_KEPLR_INJECTIVE_RPC,
    rest: process.env.VUE_APP_KEPLR_INJECTIVE_REST,
    chainName: "Injective (Beta)",
    stakeCurrency: {
      coinDenom: "INJ",
      coinMinimalDenom: "inj",
      coinDecimals: 18,
      coinGeckoId: "injective-protocol",
    },
    walletUrlForStaking: `https://app.unagii.com/stake/injective`,
    bip44: {
      coinType: 60,
    },
    bech32Config: {
      bech32PrefixAccAddr: "inj",
      bech32PrefixAccPub: "injpub",
      bech32PrefixValAddr: "injvaloper",
      bech32PrefixValPub: "injvaloperpub",
      bech32PrefixConsAddr: "injvalcons",
      bech32PrefixConsPub: "injvalconspub",
    },
    currencies: [
      {
        coinDenom: "INJ",
        coinMinimalDenom: "inj",
        coinDecimals: 18,
        coinGeckoId: "injective-protocol",
      },
    ],
    feeCurrencies: [
      {
        coinDenom: "INJ",
        coinMinimalDenom: "inj",
        coinDecimals: 18,
        coinGeckoId: "injective-protocol",
      },
    ],
    gasPriceStep: {
      low: 2500000000,
      average: 5000000000,
      high: 10000000000,
    },
    beta: true,
  },
  terra: {
    chainId: "",
    rpc: process.env.VUE_APP_KEPLR_TERRA_RPC,
    rest: process.env.VUE_APP_KEPLR_TERRA_REST,
    chainName: "Terra Classic",
    stakeCurrency: {
      coinDenom: "LUNC",
      coinMinimalDenom: "ulunc",
      coinDecimals: 6,
      coinGeckoId: "terra-lunc",
    },
    walletUrlForStaking: `https://app.unagii.com/stake/terra`,
    bip44: {
      coinType: 118,
    },
    bech32Config: {
      bech32PrefixAccAddr: "terra",
      bech32PrefixAccPub: "terraypub",
      bech32PrefixValAddr: "terravaloper",
      bech32PrefixValPub: "terravaloperpub",
      bech32PrefixConsAddr: "terravalcons",
      bech32PrefixConsPub: "terravalconspub",
    },
    currencies: [
      {
        coinDenom: "LUNC",
        coinMinimalDenom: "ulunc",
        coinDecimals: 6,
        coinGeckoId: "terra-lunc",
      },
    ],
    feeCurrencies: [
      {
        coinDenom: "LUNC",
        coinMinimalDenom: "ulunc",
        coinDecimals: 6,
        coinGeckoId: "terra-lunc",
      },
    ],
    coinType: 330,
    gasPriceStep: {
      low: 0.01,
      average: 0.025,
      high: 0.04,
    },
  },
  terrav2: {
    chainId: "",
    rpc: process.env.VUE_APP_KEPLR_TERRAV2_RPC,
    rest: process.env.VUE_APP_KEPLR_TERRAV2_REST,
    chainName: "Terra",
    stakeCurrency: {
      coinDenom: "LUNA",
      coinMinimalDenom: "uluna",
      coinDecimals: 6,
      coinGeckoId: "terra-luna",
    },
    walletUrlForStaking: `https://app.unagii.com/stake/terrav2`,
    bip44: {
      coinType: 118,
    },
    bech32Config: {
      bech32PrefixAccAddr: "terra",
      bech32PrefixAccPub: "terraypub",
      bech32PrefixValAddr: "terravaloper",
      bech32PrefixValPub: "terravaloperpub",
      bech32PrefixConsAddr: "terravalcons",
      bech32PrefixConsPub: "terravalconspub",
    },
    currencies: [
      {
        coinDenom: "LUNA",
        coinMinimalDenom: "uluna",
        coinDecimals: 6,
        coinGeckoId: "terra-luna",
      },
    ],
    feeCurrencies: [
      {
        coinDenom: "LUNA",
        coinMinimalDenom: "uluna",
        coinDecimals: 6,
        coinGeckoId: "terra-luna",
      },
    ],
    coinType: 330,
    gasPriceStep: {
      low: 0.1,
      average: 0.15,
      high: 0.2,
    },
  },
  passage3d: {
    chainId: "",
    rpc: process.env.VUE_APP_KEPLR_PASSAGE3D_RPC,
    rest: process.env.VUE_APP_KEPLR_PASSAGE3D_REST,
    chainName: "Passage3d",
    stakeCurrency: {
      coinDenom: "PASG",
      coinMinimalDenom: "upasg",
      coinDecimals: 6,
      coinGeckoId: "passage3d",
    },
    walletUrlForStaking: `https://app.unagii.com/stake/passage3d`,
    bip44: {
      coinType: 118,
    },
    bech32Config: {
      bech32PrefixAccAddr: "pasg",
      bech32PrefixAccPub: "pasgpub",
      bech32PrefixValAddr: "pasgvaloper",
      bech32PrefixValPub: "pasgvaloperpub",
      bech32PrefixConsAddr: "pasgvalcons",
      bech32PrefixConsPub: "pasgvalconspub",
    },
    currencies: [
      {
        coinDenom: "PASG",
        coinMinimalDenom: "upasg",
        coinDecimals: 6,
        coinGeckoId: "passage3d",
      },
    ],
    feeCurrencies: [
      {
        coinDenom: "PASG",
        coinMinimalDenom: "upasg",
        coinDecimals: 6,
        coinGeckoId: "passage3d",
      },
    ],
    coinType: 118,
    gasPriceStep: {
      low: 0.01,
      average: 0.025,
      high: 0.04,
    },
  },
  kujira: {
    chainId: "kaiyo-1",
    chainName: "Kujira",
    rpc: "https://rpc-kujira.starsquid.io",
    rest: "https://rest.cosmos.directory/kujira",
    bip44: {
      coinType: 118,
    },
    bech32Config: {
      bech32PrefixAccAddr: "kujira",
      bech32PrefixAccPub: "kujirapub",
      bech32PrefixValAddr: "kujiravaloper",
      bech32PrefixValPub: "kujiravaloperpub",
      bech32PrefixConsAddr: "kujiravalcons",
      bech32PrefixConsPub: "kujiravalconspub",
    },
    currencies: [
      {
        coinDenom: "KUJI",
        coinMinimalDenom: "ukuji",
        coinDecimals: 6,
        coinGeckoId: "kujira",
      },
      {
        coinDenom: "USK",
        coinMinimalDenom:
          "factory/kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7/uusk",
        coinDecimals: 6,
        coinGeckoId: "usk",
      },
      {
        coinDenom: "axlUSDC",
        coinMinimalDenom:
          "ibc/295548A78785A1007F232DE286149A6FF512F180AF5657780FC89C009E2C348F",
        coinDecimals: 6,
        coinGeckoId: "usdc",
      },
      {
        coinDenom: "ATOM",
        coinMinimalDenom:
          "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
        coinDecimals: 6,
        coinGeckoId: "cosmoshub",
      },
      {
        coinDenom: "CMDX",
        coinMinimalDenom:
          "ibc/3607EB5B5E64DD1C0E12E07F077FF470D5BC4706AFCBC98FE1BA960E5AE4CE07",
        coinDecimals: 6,
        coinGeckoId: "comdex",
      },
      {
        coinDenom: "EVMOS",
        coinMinimalDenom:
          "ibc/F3AA7EF362EC5E791FE78A0F4CCC69FEE1F9A7485EB1A8CAB3F6601C00522F10",
        coinDecimals: 18,
        coinGeckoId: "evmos",
      },
      {
        coinDenom: "JUNO",
        coinMinimalDenom:
          "ibc/EFF323CC632EC4F747C61BCE238A758EFDB7699C3226565F7C20DA06509D59A5",
        coinDecimals: 6,
        coinGeckoId: "juno",
      },
      {
        coinDenom: "OSMO",
        coinMinimalDenom:
          "ibc/47BD209179859CDE4A2806763D7189B6E6FE13A17880FE2B42DE1E6C1E329E23",
        coinDecimals: 6,
        coinGeckoId: "osmosis",
      },
      {
        coinDenom: "SCRT",
        coinMinimalDenom:
          "ibc/A358D7F19237777AF6D8AD0E0F53268F8B18AE8A53ED318095C14D6D7F3B2DB5",
        coinDecimals: 6,
        coinGeckoId: "secret",
      },
      {
        coinDenom: "STARS",
        coinMinimalDenom:
          "ibc/4F393C3FCA4190C0A6756CE7F6D897D5D1BE57D6CCB80D0BC87393566A7B6602",
        coinDecimals: 6,
        coinGeckoId: "stars",
      },
      {
        coinDenom: "wAVAX",
        coinMinimalDenom:
          "ibc/004EBF085BBED1029326D56BE8A2E67C08CECE670A94AC1947DF413EF5130EB2",
        coinDecimals: 18,
        coinGeckoId: "avalanche-2",
      },
      {
        coinDenom: "wETH",
        coinMinimalDenom:
          "ibc/1B38805B1C75352B28169284F96DF56BDEBD9E8FAC005BDCC8CF0378C82AA8E7",
        coinDecimals: 18,
        coinGeckoId: "ethereum",
      },
    ],
    feeCurrencies: [
      {
        coinDenom: "KUJI",
        coinMinimalDenom: "ukuji",
        coinDecimals: 6,
        coinGeckoId: "kujira",
      },
    ],
    stakeCurrency: {
      coinDenom: "KUJI",
      coinMinimalDenom: "ukuji",
      coinDecimals: 6,
      coinGeckoId: "kujira",
    },
    coinType: 118,
    beta: true,
    gasPriceStep: {
      low: 0.0025,
      average: 0.0025,
      high: 0.005,
    },
  },
  archway: {
    chainId: "",
    rpc: process.env.VUE_APP_KEPLR_ARCHWAY_RPC,
    rest: process.env.VUE_APP_KEPLR_ARCHWAY_REST,
    chainName: "Archway",
    stakeCurrency: {
      coinDenom: "ARCH",
      coinMinimalDenom: "aarch",
      coinDecimals: 18,
      coinGeckoId: "archway-network",
    },
    walletUrlForStaking: `https://app.unagii.com/stake/archway`,
    bip44: {
      coinType: 118,
    },
    bech32Config: {
      bech32PrefixAccAddr: "archway",
      bech32PrefixAccPub: "archwaypub",
      bech32PrefixValAddr: "archwayvaloper",
      bech32PrefixValPub: "archwayvaloperpub",
      bech32PrefixConsAddr: "archwayvalcons",
      bech32PrefixConsPub: "archwayvalconspub",
    },
    currencies: [
      {
        coinDenom: "ARCH",
        coinMinimalDenom: "aarch",
        coinDecimals: 18,
        coinGeckoId: "archway-network",
      },
    ],
    feeCurrencies: [
      {
        coinDenom: "ARCH",
        coinMinimalDenom: "aarch",
        coinDecimals: 18,
        coinGeckoId: "archway-network",
        gasPriceStep: {
          low: 1000000000000,
          average: 1500000000000,
          high: 2000000000000,
        },
      },
    ],
    coinType: 118,
    gasPriceStep: {
      low: 1000000000000,
      average: 1500000000000,
      high: 2000000000000,
    },
  },
  celestia: {
    chainId: "",
    chainName: "Celestia",
    rpc: process.env.VUE_APP_KEPLR_CELESTIA_RPC,
    rest: process.env.VUE_APP_KEPLR_CELESTIA_REST,
    bip44: {
      coinType: 118,
    },
    walletUrlForStaking: `https://app.unagii.com/stake/celestia`,
    bech32Config: {
      bech32PrefixAccAddr: "celestia",
      bech32PrefixAccPub: "celestiapub",
      bech32PrefixValAddr: "celestiavaloper",
      bech32PrefixValPub: "celestiavaloperpub",
      bech32PrefixConsAddr: "celestiavalcons",
      bech32PrefixConsPub: "celestiavalconspub",
    },
    currencies: [
      {
        coinDenom: "TIA",
        coinMinimalDenom: "utia",
        coinDecimals: 6,
        coinGeckoId: "celestia",
      },
    ],
    feeCurrencies: [
      {
        coinDenom: "TIA",
        coinMinimalDenom: "utia",
        coinDecimals: 6,
        coinGeckoId: "celestia",
        gasPriceStep: {
          low: 0.1,
          average: 0.2,
          high: 0.4,
        },
      },
    ],
    stakeCurrency: {
      coinDenom: "TIA",
      coinMinimalDenom: "utia",
      coinDecimals: 6,
      coinGeckoId: "celestia",
    },
    coinType: 118,
    gasPriceStep: {
      low: 0.1,
      average: 0.2,
      high: 0.4,
    },
  },
  canto: {
    chainId: "",
    chainName: "Canto",
    rpc: "https://rpc.cosmos.directory/canto",
    rest: "https://rest.cosmos.directory/canto",
    bip44: {
      coinType: 60,
    },
    walletUrlForStaking: `https://app.unagii.com/stake/canto`,
    bech32Config: {
      bech32PrefixAccAddr: "canto",
      bech32PrefixAccPub: "cantopub",
      bech32PrefixValAddr: "cantovaloper",
      bech32PrefixValPub: "cantovaloperpub",
      bech32PrefixConsAddr: "cantovalcons",
      bech32PrefixConsPub: "cantovalconspub",
    },
    currencies: [
      {
        coinDenom: "CANTO",
        coinMinimalDenom: "acanto",
        coinDecimals: 18,
        coinGeckoId: "canto",
      },
    ],
    feeCurrencies: [
      {
        coinDenom: "CANTO",
        coinMinimalDenom: "acanto",
        coinDecimals: 18,
        coinGeckoId: "canto",
        gasPriceStep: {
          low: 1000000000000,
          average: 1200000000000,
          high: 1500000000000,
        },
      },
    ],
    stakeCurrency: {
      coinDenom: "CANTO",
      coinMinimalDenom: "acanto",
      coinDecimals: 18,
      coinGeckoId: "canto",
    },
    coinType: 60,
    gasPriceStep: {
      low: 1000000000000,
      average: 1200000000000,
      high: 1500000000000,
    },
  }
};
